import { render } from "./app-icon-download.vue?vue&type=template&id=a81768ee"
import script from "./app-icon-download.vue?vue&type=script&lang=js"
export * from "./app-icon-download.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/icon/app-icon-download.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a81768ee"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a81768ee', __exports__)) {
    console.log('reload')
    api.reload('a81768ee', __exports__)
  }
  
  module.hot.accept("./app-icon-download.vue?vue&type=template&id=a81768ee", () => {
    console.log('re-render')
    api.rerender('a81768ee', render)
  })

}


export default __exports__